// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__lppo5","box":"style_box__A8K2D","active":"style_active__mat9q","title":"style_title__EJDtG","item":"style_item__3MriP"};